/**
 * Title: "Helpers for trigger form validation"
 *
 * Description: "Trigger input validation for components in UI Kit"
 * 
 * Author: tijanirf@gmail.com
 * 
 * Version:
 * - v 1.0.0 (14 March 2019): Specifically trigger validation for Input (all validation) and SelectDropdown 
 *                            (NotEmpty validation) Component.
 * 
 * 
 * @param {Object}  fields      Object that holds field values.
 *                              Example = model: {input1: null, input2: null, dropdown1: null, input3: null }.
 * 
 * @param {Object}  fieldRefs   Object that holds field custom refs, the property must be in order.
 *                              Property naming matters, for instance input property must have 'input' word, and so on.
 *                              Example = dataRef: {input1: 'input1', input2: 'input2', dropdown1: 'dropdown1', input3: 'input3'}.
 * 
 * @param {Object}  refs        Vue's $refs variable.
 * 
 * @param {Object}  errors      Object that holds field error values.
 *                              Example = error: {input1: null, input2: null, dropdown1: null, input3: null }.
 * 
 * @return {boolean}
 */


const triggerValidation = (fields, fieldRefs, refs, errors) => {
  let isValid = true

  for (let key in fieldRefs) {
    let element = null

    if (key.toLowerCase().includes('input')) {
      if (refs[key] && refs[key].constructor.name=='Array'){
        for (var i = 0 ; i < refs[key].length; i++){
          element = refs[key][i].$el.firstElementChild
          element.focus()
          element.blur()
          if (errors[key][i]) {
            isValid = false
            break;
          }
        }
      } else {
        element = refs[key].$el.firstElementChild
        element.focus()
        element.blur()
        if (errors[key]) {
          isValid = false
          break;
        }
      }   
    } else if (key.toLowerCase().includes('dropdown')) {
      fields[key] = ''
      if (refs[key] && refs[key].constructor.name!='Array' && errors[key] != false) {
        isValid = false
        break
      }
    }
  }

  return isValid
}

export default triggerValidation;